import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white p-6 rounded-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "uppercase font-semibold text-sm text-blue-400" }, "Тарифная сетка", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_zones_modal = _resolveComponent("zones-modal")!
  const _component_zones_tabs = _resolveComponent("zones-tabs")!
  const _component_zones_grid = _resolveComponent("zones-grid")!
  const _component_standard_params_grid = _resolveComponent("standard-params-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.state.is_modal_opened)
      ? (_openBlock(), _createBlock(_component_zones_modal, {
          key: 0,
          onCancel: _ctx.onCloseModal
        }, null, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_zones_tabs, {
      class: "mt-5",
      value: _ctx.state.selected_zone_id,
      disabled: _ctx.state.is_loading,
      onChange: _ctx.onChangeZone,
      onOpenModal: _ctx.onOpenModal
    }, null, 8, ["value", "disabled", "onChange", "onOpenModal"]),
    _createVNode(_component_zones_grid, {
      class: "mt-5",
      loading: _ctx.state.is_loading,
      failed: _ctx.state.is_failed,
      "zone-id": _ctx.state.selected_zone_id,
      "auto-tariffs": _ctx.state.auto_tariffs,
      "avia-tariffs": _ctx.state.avia_tariffs,
      onRefresh: _ctx.loadZone
    }, null, 8, ["loading", "failed", "zone-id", "auto-tariffs", "avia-tariffs", "onRefresh"]),
    (!_ctx.state.is_failed && !_ctx.state.is_loading)
      ? (_openBlock(), _createBlock(_component_standard_params_grid, {
          key: 1,
          class: "mt-5",
          "standard-params": _ctx.state.standard_params
        }, null, 8, ["standard-params"]))
      : _createCommentVNode("", true)
  ]))
}